import { Box, ButtonProps, Typography } from '@mui/material'
import React from 'react'
import { ctaIconsByCategory } from '../constants/actions'
import { giveLivelyState } from '../context/give-lively-context'
import ResultCardCtaSingle from './result-card/result-card-cta-single'

export const GiveLivelyDonateButton = ({
  organization,
  action_id,
  isCompleted,
  ...buttonProps
}: {
  organization: Queries.SanityOrganization
  action_id: string
  isCompleted?: boolean
} & ButtonProps) => {
  const { donateTo } = giveLivelyState()

  return (
    <Box>
      <ResultCardCtaSingle
        {...buttonProps}
        isCompleted={isCompleted}
        label={
          <Typography fontSize={24} fontWeight={500} lineHeight={1.5}>
            Donation Form
          </Typography>
        }
        icon={ctaIconsByCategory['donate']}
        onClick={e => {
          buttonProps.onClick?.(e)
          donateTo(organization, action_id)
        }}
      />
    </Box>
  )
}
